import domWrap from "../utils/domWrap";
import throttle from "../utils/throttle";

export default async revealer => { // 'comp-revealer'
	const revealerFigures = [...revealer.querySelectorAll(':scope > figure')];
	revealerFigures.forEach(figure => drags(domWrap(figure.querySelector('span')),domWrap(figure.querySelector('div')), domWrap(figure)));
	domWrap(revealer.querySelector('nav')).on('click','button',function(){
		const index = this.getAttribute('index');
		domWrap(revealer.querySelector(`[index="${index}"]`)).setSelected('active');
	});
	
	const checkPosition = throttle(() => {
		revealerFigures.forEach(container => {
			if( window.scrollY + window.innerHeight * 0.5 > domWrap(container).offset().top) {
				container.classList.add('is-visible');
				window.removeEventListener('scroll',checkPosition);
			}
		});
	},500);
	
	window.addEventListener('scroll',checkPosition);
	checkPosition();
};

function drags(dragElement, resizeElement, container) {
	const parent = dragElement.parentNode;
	let dragWidth = dragElement.offsetWidth,
		xPosition,
		containerOffset = container.offset().left,
		containerWidth = container.offsetWidth,
		minLeft = containerOffset + 10,
		maxLeft = containerOffset + containerWidth - dragWidth - 10,
		dragging = false;
	dragElement.addEventListener('pointerdown',e => {
		e.preventDefault();
		xPosition = dragElement.offset().left + dragWidth - e.pageX
		dragging = true;
	});
	parent.addEventListener('pointermove',e => {
		let leftValue = e.pageX + xPosition - dragWidth;
		//constrain the draggable element to move inside its container
		if(leftValue < minLeft ) {
			leftValue = minLeft;
		} else if ( leftValue > maxLeft) {
			leftValue = maxLeft;
		}

		let widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
		
		if(dragging){
			dragElement.style.left = widthValue;
			resizeElement.style.width = widthValue;
		}
	});
	dragElement.addEventListener('pointerup',() => dragging = false);
	parent.addEventListener('pointerup',() => dragging = false);
}